module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-short-icon.88c3885e.svg";